import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Carousel, Row, Col } from 'react-bootstrap';
// import { themeBg } from '../../constants/carousel';

const CarouselCP = (props) => {
  const { items } = props;
  // const setColor = (color) => {
  //   const colorSelected = themeBg.filter((theme) => theme.name === color.toLowerCase());
  //   return colorSelected[0].clase;
  // };

  return (
    <div className="container-fluid px-0">
      <Carousel className="mb-0" controls={items.length > 1} indicators={items.length > 1}>
        {
          items.map((c) => {
            return (
              <Carousel.Item key={c.id}>
                <Row>
                  <Col lg={6} className="px-0 d-lg-none d-xl-none">
                    <img
                      className="d-block w-100"
                      src={c.imageUrlMobile}
                      alt="First slide"
                      width="100%"
                      height="140" />
                  </Col>
                  <Col lg={6} className="px-0 bg-color-tangaroa">
                    <div className="caption-cp">
                      <h1 className="text-white">
                        {c.title}
                      </h1>
                      <p className="text-white my-15">
                        {c.description}
                      </p>
                      <Link to={`/${(c.title).replace(/\s/g, '-')}/${c.experienceId}`} className="btn btn-primary-dark">{c.buttonText}</Link>
                    </div>
                  </Col>
                  <Col lg={6} className="px-0 d-none d-lg-block d-xl-block">
                    <img
                      className="d-block w-100 bnn-height"
                      src={c.imageUrl}
                      alt="First slide"
                      width="623" />
                  </Col>
                </Row>
              </Carousel.Item>
            );
          })
        }
      </Carousel>
    </div>
  );
};

CarouselCP.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    imageUrl: PropTypes.string.isRequired,
    imageUrlMobile: PropTypes.string.isRequired,
    order: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    experienceId: PropTypes.string.isRequired,
  })).isRequired,
};

export default CarouselCP;
